import * as React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbTableTHeadRow } from '@celebration/design-system/dist/lib/table-thead-row';

export default createComponent({
    react: React,
    elementClass: ClbTableTHeadRow,
    tagName: ClbTableTHeadRow.tagName,
    events: ClbTableTHeadRow.events,
});
